import orderReceived from "./partials/order-received";

jQuery(function ($) {
    orderReceived.init();
});
